import { render, staticRenderFns } from "./EventSubscriptionsGrid.vue?vue&type=template&id=122cc80c&"
import script from "./EventSubscriptionsGrid.vue?vue&type=script&lang=js&"
export * from "./EventSubscriptionsGrid.vue?vue&type=script&lang=js&"
import style0 from "./EventSubscriptionsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports